import React, { useState } from "react";
import { Pagination } from "antd";
import BoardSaleOne from "./BoardSaleOne";
import BoardSaleTwo from "./BoardSaleTwo";
import BoardSaleTree from "./BoardSaleTree";

export const BoardSale = () => {
  const [currentPage, setCurrentPage] = useState(1);
  const itemsPerPage = 1;
  const componentsToShow = [BoardSaleOne, BoardSaleTwo, BoardSaleTree];

  const handlePageChange = (page) => {
    setCurrentPage(page);
  };

  return (
    <div
    className="relative min-h-screen flex flex-col"
     
    >
      <div className="flex-1">
        {componentsToShow.map((Component, index) => {
          if (index === currentPage - 1) {
            return <Component key={index} />;
          }
          return null;
        })}
      </div>
      <div className="flex justify-end items-center mb-5" >
        <Pagination
          current={currentPage}
          pageSize={itemsPerPage}
          total={componentsToShow.length}
          onChange={handlePageChange}
        />
      </div>
    </div>
  );
};
